import React, { Component } from 'react'

class AboutUs extends Component {
  render () {
    return (
      <div className='App'>
        <h1 className='App-title'>About Us</h1>
      </div>
    )
  }
}

export default AboutUs



// WEBPACK FOOTER //
// ./src/components/AboutUs.js